import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";
import {
    SettingHierarchyItem,
    SettingRangeItem,
    SettingStatusItem,
    UpdateSettingHierarchyItem,
    UpdateSettingRangeItem
} from "@/models";

export class SettingFilterService {
    public static readonly $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    getStatusCodeByCountry(countryId: number, cancelToken: AbortSignal = null) {
        return this.baseApiFactory.getData<SettingStatusItem[]>(`/api/SettingFilter/${countryId}/status`, {}, cancelToken);
    }

    getSeriesByCountry(countryId: number, cancelToken: AbortSignal = null) {
        return this.baseApiFactory.getData<SettingRangeItem[]>(`/api/SettingFilter/${countryId}/range`, {}, cancelToken);
    }

    getTypesByCountry(countryId: number, langCode: string, cancelToken: AbortSignal = null) {
        return this.baseApiFactory.getData<SettingHierarchyItem[]>(`/api/SettingFilter/${countryId}/hierarchy`, {
            langCode
        }, cancelToken);
    }

    updateStatusCodeByCountry(countryId: number, items: SettingStatusItem[], cancelToken: AbortSignal = null) {
        return this.baseApiFactory.put<boolean>(`/api/SettingFilter/${countryId}/status`, items, cancelToken);
    }

    updateSeriesByCountry(countryId: number, items: UpdateSettingRangeItem[], cancelToken: AbortSignal = null) {
        return this.baseApiFactory.put<boolean>(`/api/SettingFilter/${countryId}/range`, items, cancelToken);
    }

    updateTypesByCountry(countryId: number, items: UpdateSettingHierarchyItem[], cancelToken: AbortSignal = null) {
        return this.baseApiFactory.put<boolean>(`/api/SettingFilter/${countryId}/hierarchy`, items, cancelToken);
    }
}

lazyRegister.service('SettingFilterService', SettingFilterService);
